































import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders, VAction } from '@/models/pagedlistmodel';
import { OrphanViewModel, Orphan } from '@/models/filebunker/orphan.attachment';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import { getOrphanAttachmentListHeaders } from '@/views/fileBunker/orphan/orphanList';
import {
  attachmentTypeService,
  orphanAttachmentService,
  attachmentService,
} from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    pages() {
      return this.pagedDeals.totalPages;
    },
    validate() {
      return (
        this.selectedPaymentType &&
        Number(this.amountToBePaid) <= Number(this.finalAmount) &&
        Number(this.amountToBePaid) > 0 &&
        this.amountToBePaid !== '0.00'
      );
    },
    isValidTransactionAmount() {
      this.dollarDialog.action.disable = !this.validate;
    },
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
})
class OrphanAttachmentPage extends Base {
  public headers: VHeaders[] = getOrphanAttachmentListHeaders(this);
  public loading: boolean = false;
  public pagedAttachments: OrphanViewModel[] = [];
  public attachmentTypes: any = [];
  public paginations = new PaginationModel('createdAt');
  public barCodeLoader: boolean = false;
  public orphanAttachmentLoader: boolean = false;
  public editDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('orphanList.editDialog.title') as string,
    model: false,
    action: {
      color: 'primary',
      icon: 'fas fa-edit',
      text: this.$parent.$t('orphanList.editDialog.lblUpdate') as string,
    },
    loading: false,
    onAction: (): void => {
      this.updateAttachment();
    },
  };
  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('orphanList.deleteDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('orphanList.deleteDialog.lblAgree') as string,
    },
    onAction: (): void => {
      this.deleteAttachmentType();
    },
  };
  public attachmentTypeToggle: boolean = false;
  public identifier: string = '';
  public identifierLabel: string = '';
  public types = [{ name: 'Deal' }, { name: 'Vehicle' }, { name: 'RO' }];
  public orphanModel: Orphan = {};
  public actions: VAction[] = [];
  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        color: 'error',
        title: this.$t('orphanList.orphanGrid.gridAction.delete') as string,
        action: (model: OrphanViewModel) => {
          this.showDeleteDialog(model.attachmentUri);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: this.$t('orphanList.orphanGrid.gridAction.view') as string,
        loading: false,
        action: (model: OrphanViewModel, action: VAction) => {
          this.openAttachment(model.attachmentUri, action);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-download',
        title: this.$t('orphanList.orphanGrid.gridAction.download') as string,
        loading: false,
        action: (model: OrphanViewModel, action: VAction) => {
          this.downloadFile(model.attachmentUri, action);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-edit',
        title: this.$t(
          'orphanList.orphanGrid.gridAction.editAttachment'
        ) as string,
        action: (model: OrphanViewModel) => {
          this.showEditDialog(model.attachmentUri);
        },
      },
    ];
  }

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'orphanAttachment');

    this.identifierLabel = this.$t('orphanList.lblDealNumber') as string;
    this.setActions();

    const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
    if (pagination) {
      this.paginations = pagination;
    }

    this.getOrphanAttachments();
    this.getAttachmentTypes();
  }

  public async getOrphanAttachments(): Promise<void> {
    try {
      this.loading = true;
      const attachments = await orphanAttachmentService.getOrphanAttachments();
      this.pagedAttachments = attachments.results;
      this.paginations.totalItems = attachments.total;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(page: PaginationModel) {
    this.paginations = page;
    const queryStringObj = Object.assign({}, page);
    Utils.validateAndUpdateRoute(queryStringObj);
    // this.getOrphanAttachments();
  }

  public async getAttachmentTypes(): Promise<void> {
    const attachmentTypes = await attachmentTypeService.getAttachmentTypes();
    this.attachmentTypes = attachmentTypes.results;
  }

  public async openAttachment(uri: string, action: VAction): Promise<void> {
    if (!uri) {
      this.showAlert(false, this.$t('orphanList.alertUriNotFound'));
      return;
    }

    try {
      action.loading = true;
      this.orphanAttachmentLoader = true;
      await attachmentService.viewAttachmentByUriAsync(uri);
    } finally {
      action.loading = false;
      this.orphanAttachmentLoader = false;
    }
  }
  public async downloadFile(
    attachmentUri: string,
    action: VAction
  ): Promise<void> {
    try {
      action.loading = true;
      this.barCodeLoader = true;
      const attachment = await orphanAttachmentService.downloadAttachment(
        attachmentUri
      );
      const bytes = _file.base64ToArrayBuffer(attachment.fileContent);
      _file.downloadBytes(bytes, '', attachment.fileDownloadName);
    } finally {
      action.loading = false;
      this.barCodeLoader = false;
    }
  }

  public async updateAttachment(): Promise<void> {
    if (this.validateForm()) {
      this.orphanModel.identifier = this.identifier;
      if (!this.orphanModel.identifierType || !this.orphanModel.identifier) {
        this.showAlert(
          false,
          this.$t('orphanList.alertSelectType') +
          this.identifierLabel +
          this.$t('orphanList.alertFieldRequired')
        );
        return;
      }

      if (this.orphanModel.identifierType == 'RO') {
        if (!this.orphanModel.attachmentTypeId) {
          this.showAlert(false, 'Select Attachment Type');
          return;
        }
      }
      try {
        this.editDialog.loading = true;
        this.$emit('update:progress', this.editDialog.loading);

        await orphanAttachmentService.updateAttachment(this.orphanModel);
        this.showAlert(true, this.$t('orphanList.alertAttachmentUpdated'));
        this.getOrphanAttachments();
      } finally {
        this.editDialog.loading = false;
        this.editDialog.model = false;
        this.$emit('update:progress', this.editDialog.loading);
      }
    }
  }

  public showEditDialog(attachmentUri: string): void {
    this.identifier = '';
    this.orphanModel = {};
    this.orphanModel.attachmentUri = attachmentUri;
    this.attachmentTypeToggle = false;
    this.editDialog.model = true;
  }

  public showDeleteDialog(uri: string) {
    this.orphanModel.attachmentUri = uri;
    this.deleteDialog.model = true;
  }

  public async deleteAttachmentType(): Promise<void> {
    if (!this.orphanModel.attachmentUri) {
      this.showAlert(false, this.$t('orphanList.alertAttachmentNotFound'));
      return;
    }
    try {
      this.deleteDialog.loading = true;
      await orphanAttachmentService.deleteAttachment(
        this.orphanModel.attachmentUri
      );
      this.showAlert(true, this.$t('orphanList.alertAttachmentDeleted'));
      this.getOrphanAttachments();
    } finally {
      this.deleteDialog.loading = false;
      this.deleteDialog.model = false;
    }
  }

  public typeChange(selectedType: string): void {
    this.orphanModel.identifierType = selectedType;
    this.identifier = '';
    switch (selectedType) {
      case 'Deal':
        this.identifierLabel = this.$t('orphanList.lblDealNumber') as string;
        this.attachmentTypeToggle = false;
        break;
      case 'Vehicle':
        this.identifierLabel = this.$t('orphanList.lblVIN') as string;
        this.attachmentTypeToggle = false;
        break;
      case 'RO':
        this.identifierLabel = this.$t('orphanList.lblRONumber') as string;
        this.attachmentTypeToggle = true;
        break;
      default:
        this.identifierLabel = '';
    }
  }
}
export default OrphanAttachmentPage;
